(function () {
  function initSection(root) {
    if (!root || root.dataset.gbReady === '1') return;
    root.dataset.gbReady = '1';

    const imageTrack = root.querySelector('.gb-slider-track');
    const titleTrack = root.querySelector('.gb-titles-track');
    const nextBtn    = root.querySelector('.gb-slider-button--next');
    const prevBtn    = root.querySelector('.gb-slider-button--prev');
    if (!imageTrack || !titleTrack) return;

    const reals = (el) => Array.from(el.children).filter(n => !n.classList.contains('is-clone'));
    const realSlides = reals(imageTrack);
    const realTitles = reals(titleTrack);
    const totalReal  = realSlides.length;
    if (totalReal < 2) return;

    const spv = () => matchMedia('(max-width: 749px)').matches ? 1 : 2;
    const clonesPerSide = Math.max(2, spv());

    if (!imageTrack.querySelector('.is-clone')) {
      for (let i = 0; i < clonesPerSide; i++) {
        const a = realSlides[i].cloneNode(true); a.classList.add('is-clone'); imageTrack.appendChild(a);
        const b = realTitles[i].cloneNode(true); b.classList.add('is-clone'); titleTrack.appendChild(b);
      }
      for (let i = 0; i < clonesPerSide; i++) {
        const a = realSlides[totalReal-1-i].cloneNode(true); a.classList.add('is-clone'); imageTrack.insertBefore(a, imageTrack.firstChild);
        const b = realTitles[totalReal-1-i].cloneNode(true); b.classList.add('is-clone'); titleTrack.insertBefore(b, titleTrack.firstChild);
      }
    }

    let index = clonesPerSide, locked = false;
    const slideW = () => imageTrack.children[0].getBoundingClientRect().width;
    const setPos = (instant=false) => {
      const t = instant ? 'none' : 'transform .5s cubic-bezier(0.25,1,.5,1)';
      const x = -index * slideW();
      [imageTrack, titleTrack].forEach(tr => { tr.style.transition=t; tr.style.transform=`translateX(${x}px)`; });
    };
    const normalize = () => {
      const min = clonesPerSide, max = totalReal + clonesPerSide;
      if (index < min) { index += totalReal; setPos(true); }
      else if (index >= max) { index -= totalReal; setPos(true); }
    };

    imageTrack.addEventListener('transitionend', normalize);
    const move = (d) => { if (locked) return; locked = true; index += d; setPos(false); setTimeout(()=>locked=false,520); };
    nextBtn?.addEventListener('click', () => move(1));
    prevBtn?.addEventListener('click', () => move(-1));

    const toggleArrows = () => {
      const hide = totalReal <= spv();
      [nextBtn, prevBtn].forEach(b => { if (b) b.style.display = hide ? 'none' : ''; });
    };
    const onResize = () => { toggleArrows(); setPos(true); };
    addEventListener('resize', onResize);

    root.querySelectorAll('img').forEach(img => {
      if (!img.complete) img.addEventListener('load', () => setPos(true), { once:true });
    });

    requestAnimationFrame(() => { toggleArrows(); setPos(true); });

    // Limpieza en editor
    document.addEventListener('shopify:section:unload', (e) => {
      if (e.target?.contains(root)) removeEventListener('resize', onResize);
    });
  }

  function boot(scope=document) {
    scope.querySelectorAll('.gb-section').forEach(initSection);
  }

  // Exponer para Swup
  window.GBGallery = { boot };

  document.addEventListener('DOMContentLoaded', () => boot(document));
  document.addEventListener('page:changed', () => boot(document));
})();